module.exports = __webpack_public_path__ + "img/col.1ded4acc.svg";